export const environment = {
  apiUrl: 'https://rapipagoonline.app/api',
  token:'no molestar'
};
